// Small patient-app UI atoms layered on @championcare/ui primitives.
import type { ReactNode } from "react";
import { Pill } from "@championcare/ui";
import type { SyncTone } from "../lib/window-guard";

export function Loading({ label = "Loading…" }: { label?: string }) {
  return <div className="state state--loading">{label}</div>;
}

export function ErrorState({ message }: { message: string }) {
  return <div className="state state--error">{message}</div>;
}

export function EmptyState({ children }: { children: ReactNode }) {
  return <div className="state state--empty">{children}</div>;
}

const STATUS_TONE: Record<string, "default" | "gold" | "blood"> = {
  scheduled: "default",
  confirmed: "default",
  live: "blood",
  completed: "default",
  cancelled: "default",
  no_show: "default",
};

export function StatusPill({ status }: { status: string }) {
  return <Pill variant={STATUS_TONE[status] ?? "default"}>{status.replace("_", " ")}</Pill>;
}

export function SyncBadge({ tone, label }: { tone: SyncTone; label: string }) {
  return <span className={`sync sync--${tone}`}>{label}</span>;
}

export function PageHeader({ title, sub }: { title: string; sub?: string }) {
  return (
    <header className="page-head">
      <h1 className="page-head__title">{title}</h1>
      {sub && <p className="page-head__sub">{sub}</p>}
    </header>
  );
}
